/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'gslb';
const componentName = 'gslb-client-ip-addr-group-config';
const prefix = `${moduleName}.${componentName}`;

export const clientGroupTypeLabel = `${prefix}.clientGroupTypeLabel`;
export const clientGroupIpAddressLabel = `${prefix}.clientGroupIpAddressLabel`;

export const ENGLISH = {
    [clientGroupTypeLabel]: 'Client Group Type',
    [clientGroupIpAddressLabel]: 'Client Group IP Address ({0})',
};
